import React, { Component } from 'react';
import { Field } from 'redux-form';
import { intlShape, injectIntl } from 'react-intl';
import SelectField from '../../../../shared-components/SelectField/SelectField';
import { isEmpty } from '../../../../shared-components/FormElement/FormElementUtils';

const LOCALE_PREFIX = 'US/pages/BillingAddressPage/BillingAddressForm';

const getStateOptions = (intl, localePrefix) => {
    return intl
        .formatMessage({ id: `${localePrefix}.stateList` })
        .split(', ')
        .map((state) => ({
            id: state,
            displayText: state
        }));
};

export class State extends Component {
    static propTypes = {
        intl: intlShape.isRequired
    };

    render() {
        const { intl } = this.props;
        const stateList = getStateOptions(intl, LOCALE_PREFIX);

        return (
            <Field
                id="state"
                name="state"
                component={SelectField}
                label={intl.formatMessage({id: `${LOCALE_PREFIX}.state-label`})}
                placeholder={intl.formatMessage({id: `${LOCALE_PREFIX}.state-placeholder`})}
                optionList={stateList}
                validate={[isEmpty(intl.formatMessage({id: `${LOCALE_PREFIX}.billinginfo-empty`}))]}
            />
        );
    }
}

export default injectIntl(State);
